
var ECM = (window.ECM = window.ECM || {});
(function ($, ECM) {
    var errorClass = 'has-error';
    var errorElementSelector = function (element) {
        var el = $(element).parents('.row')[0];
        return $(el);
    };
    
    $.fn.ecmValidateFormButton = function () {
        this.bind('click', function (e) {
            var me = this;
            $('.ecm-error-message').remove();
            $('.' + errorClass).removeClass(errorClass);
            var errors = 0;
            // check required values
            $(me).parents('form').find('.required').each(function () {
                var row = $(this).parents('.row')[0];
                if (row) {
                    row = $(row);
                    if (!this.value && !row.hasClass('error')) {
                        errors++;
                        row.addClass('has-error')
                        row.data('error', 'Dit veld is verplicht');
                    }
                }
            });
            $('.trigger-change-on-submit').trigger('ecm-validate');
            errors += $(me).parents('form').find('.' + errorClass).length;

            if (errors > 0) {
                e.preventDefault();
                // display messages
                $(me).parents('form').find('.has-error').each(function () {
                    var el = $(this),
                        message = el.data('error');
                    el = el.find('input');

                    if (message && el.length > 0) {
                        var div = el.parent();
                        $('<div class="ecm-error-message alert alert-danger fade in"></div>').text(message).prependTo(div);
                    }

                    
                });


                alert('Een of meer velden zijn niet correct gevuld.')
            }            
        });

    };
    
    $.isValidIban = function(iban) {
        var charMap = {};
        for (var i = 0; i < 26; i++) {
            charMap[String.fromCharCode(65 + i)] = i + 10;
        }
        var val = iban,
            valid = true;
        if (!val) {
            return false;
        }
        val = val.replace(/[^a-zA-Z0-9]/,'').toUpperCase();
        valid = valid && /^[a-zA-Z]{2}\d{2}[a-zA-Z0-9]{1,30}$/.test(val);
        if (valid) {
            var land = val.substr(0, 2),
                crc = val.substr(2, 2),
                tmp = val.substr(4)  + land + crc;
            val = '';
            for (var i = 0; i < tmp.length; i++) {
                var c = tmp.charAt(i);
                if (/\D/.test(c) && charMap.hasOwnProperty(c)) {
                    val += '' + charMap[c];
                } else {
                    val += c;
                }
            }
            var cRest = '', cOperator, cChar;
            // Calculate the result of: ibancheckdigits % 97
            for (var p = 0; p < val.length; p++) {
                cChar = val.charAt(p);
                cOperator = "" + cRest + "" + cChar;
                cRest = cOperator % 97;
            }
            valid = valid && cRest === 1;
        }
        return valid; 
    };

    $.fn.ecmValidateIban = function () {
        //var charMap = {};
        //for (var i = 0; i < 26; i++) {
        //    charMap[String.fromCharCode(65 + i)] = i + 10;
        //}
        this.bind('change ecm-validate', function (e) {
            if (e.type != 'ecm-validate') {
                errorElementSelector(this).removeClass(errorClass);
            }
            var val = this.value,
                valid = true;
            if (!val) {
                return;
            }
            valid = $.isValidIban(val);
            if (valid && this.value == '' && $(this).hasClass('required')) {
                valid = false;
            }
            if (!valid) {
                errorElementSelector(this).addClass(errorClass).data('error', 'Ongeldig IBAN rekening nummer');
            }
        });

    };
    $.fn.ecmEmailField = function () {
        this.bind('change ecm-validate', function (e) {
            if (e.type != 'ecm-validate') {
                errorElementSelector(this).removeClass(errorClass).data('error', '');
            }
            var val = this.value,
                valid=true;
            if (!val) {
                return;
            }
            valid = /^.+\@.+\..+$/.test(val);
            if (!valid) {
                errorElementSelector(this).addClass(errorClass).data('error', 'Ongeldig e-mail adres');
            }
        });

    };

    $.fn.ecmPhoneField = function () {
        this.bind('change ecm-validate', function (e) {
            if(e.type != 'ecm-validate') {
                errorElementSelector(this).removeClass(errorClass);
            }
            var val = this.value.replace(/[^0-9\+]/, '');
            if (!val) {
                return;
            }

            if (/^(\+31|0031)\d{9}$/.test(val)) {
                return;
            } else if (val.length == 10 && val.indexOf('0') == 0) {
                return;
            } else if (/^(\+|00)\d\d\d+$/.test(val) && val.indexOf('0031') !== 0 && val.indexOf('+31') !== 0) {
                return;
            } else {
                errorElementSelector(this).addClass(errorClass).data('error', 'Ongeldig telefoon nummer');
            }

        });

    };


    $.fn.ecmDateField = function () {
        var log = $.noop;
        //log = function (msg) { console.log(msg); }

        var me = this;
        me.bind('keyup change focus blur ecm-validate', function (e) {
            if (e.type == 'focus') {
                errorElementSelector(this).removeClass(errorClass);
            } else if (e.type == 'change' || e.type == 'blur' || e.type == 'ecm-validate') {
                if (e.type != 'ecm-validate') {
                    errorElementSelector(this).removeClass(errorClass);
                }
                // validate
                if (!this.value || /\d\d?-\d\d?-\d{4}/.test(this.value)) {

                } else {
                    // invalid
                    errorElementSelector(this).addClass(errorClass).data('error', 'Ongeldig datum formaat');
                }
            } else {
                if (!this.value) {
                    return;
                }
                var value = this.value;
                if (value.length > 1 && value.indexOf('-') != -1) {
                    value = value.split('-');
                    for (var i = 0; i < value.length; i++) {
                        if (!value[i]) {
                            continue;
                        }
                        if (i < 2 && value[i] && value[i].length < 2) {
                            value[i] = '0' + value[i];
                        }

                        if (i == 0 && value[i].length < 3 && parseInt(value[i], 10) > 31) {
                            value[i] = '31';
                        } else if (i == 1 && value[i].length < 3 && parseInt(value[i], 10) > 12) {
                            value[i] = '12';
                        } else if (i == 2) {
                            if (value[i].length == 4 && parseInt(value[i], 10) > 2100) {
                                value[i] = '2200';
                            }
                            if (value[i].length == 4 && parseInt(value[i], 10) < 1900) {
                                value[i] = '1800';
                            }
                            //if (value[i].length == 2 && parseInt(value[i], 10) != 19 && parseInt(value[i], 10) != 20) value[i] = '20' + value[i];
                        }

                    }
                    value = value.join('-');
                }
                log('Source: "' + this.value + '". Modified: "' + value + '"');
                var result = '';
                var digitCount = 0;
                var sepCount = 0;
                for (var i = 0; i < value.length; i++) {
                    var v = value.charAt(i);
                    if (/\d/.test(v)) {
                        var max = sepCount == 2 ? 4 : 2;
                        if (digitCount >= max) {
                            log('AutoInsert SC: "' + sepCount + '". Modified: "' + value + '". Result=' + result);
                            if (sepCount >= 2) {
                                continue;
                            }
                            // auto insert -
                            value = value.substr(0, i) + '-' + value.substr(i);
                            i--;
                            continue;
                        } else {
                            digitCount++;
                            result += v;
                        }
                    } else if (v == '-') {
                        if (i > 0 && value.charAt(i - 1) != v && sepCount < 3) {
                            sepCount++;
                            result += v;
                            digitCount = 0;
                        }
                    }

                }
                if (this.value != result) {
                    this.value = result;
                }
            }
        });
    };
})(jQuery, ECM);


